import React, { memo, useState } from 'react';

import { useRecoilState, useSetRecoilState } from 'recoil';

import OptionButton from '@/components/common/OptionButton/OptionButton';
import { SelectedRow } from '@/pages/ContractLines/hooks/useGridSelectionSubscription';
import { UsageLineSelectionPayload, clearLinesSelection } from '../../UsageDetails/usageDetailsSelectionObservable';
import { UsageDetailDataInputType } from '@/graphql/contracts/_generated_/contracts';
import AgConfirmationModal from '@/components/common/ModalWindow/AgConfirmationModal';
import { checkedIds } from '../../UsageDetails/checkedIds.state';
import { rightsidePanel_isOpen } from '../RightPanel.state';
import { TabKeys } from '@/pages/ImportingTool/types';
import useRestoreUsageDetails from '../../hooks/useRestoreUsageDetails';
import PlusIcon from '@/components/common/OptionButton/icons/Plus/PlusIcon';

interface IRestoreContainerProps {
  selectedUsageDetails: SelectedRow<UsageLineSelectionPayload>[];
  onRestoreAction: (tabName: TabKeys) => void;
}

function RestoreStatusContainer({ selectedUsageDetails, onRestoreAction }: IRestoreContainerProps) {
  const { restoreUsageDetails } = useRestoreUsageDetails();
  const [selectedRowIds, setSelectedRowIds] = useRecoilState(checkedIds);
  const setIsOpenRightPanel = useSetRecoilState(rightsidePanel_isOpen);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const usageHeaderId = selectedUsageDetails.length > 0 &&
    selectedUsageDetails[0].payload.usageDetailsLine.usageHeaderID;

  const selectedUsageDetailsIds = selectedRowIds?.reduce((ids: UsageDetailDataInputType[], id) =>
    [...ids, { usageDetailId: id }], []);

  const handleRestoreUsageDetails = () => {
    if (usageHeaderId) {
      restoreUsageDetails(usageHeaderId, selectedUsageDetailsIds).then((result) => {
        if (result?.usageHeaderID) {
          onRestoreAction(TabKeys.ALL);
          setSelectedRowIds([]);
          clearLinesSelection();
          setIsOpenRightPanel(false);
        }
      });
    }
  };

  if (selectedUsageDetails.length === 0) {
    return null;
  }

  return (
    <>
      <AgConfirmationModal
        isOpen={showConfirmationModal}
        contentStyle={{ width: 450 }}
        onClose={() => {
          setShowConfirmationModal(false);
        }}
        onConfirm={handleRestoreUsageDetails}
        title="Restoring selected lines"
      >
        You are about to restore the selected usage records.<br />
        Please, confirm if you would like to proceed.

      </AgConfirmationModal>
      <OptionButton
        onClick={() => setShowConfirmationModal(true)}
        Icon={<PlusIcon />}
        className={'m-0'}
      >
        Restore ignored lines
      </OptionButton>
    </>
  );
}

export default memo(RestoreStatusContainer);
